import React from 'react';
import { Map, ExternalLink } from 'lucide-react';

// Source: FastExpert agent profile "Areas Served" list.
// Per-ZIP transaction counts are NOT published by any free source, so we
// intentionally omit them rather than fabricate numbers.
const servedAreas = [{
  zip: '92373',
  name: 'Redlands'
}, {
  zip: '92399',
  name: 'Yucaipa'
}, {
  zip: '92346',
  name: 'Highland'
}, {
  zip: '92359',
  name: 'Mentone'
}, {
  zip: '92320',
  name: 'Calimesa'
}, {
  zip: '92324',
  name: 'Colton'
}, {
  zip: '92313',
  name: 'Grand Terrace'
}, {
  zip: '92318',
  name: 'Bryn Mawr'
}, {
  zip: '92408',
  name: 'San Bernardino'
}];
export function MarketsServed() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px]" data-id="element-145">
      <div className="bg-white rounded-3xl p-8 md:p-10 shadow-premium border border-brand-light" data-id="element-146">
        <div className="flex items-center gap-3 mb-2" data-id="element-147">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest" data-id="element-148">
            <Map size={24} data-id="element-149" />
          </div>
          <div data-id="element-150">
            <h2 className="text-2xl font-serif text-brand-dark" data-id="element-151">
              Markets served
            </h2>
            <p className="text-sm text-brand-muted" data-id="element-152">
              Inland Empire coverage
            </p>
          </div>
        </div>
        <p className="text-xs text-brand-muted mb-6" data-id="element-153">
          Source:{' '}
          <a href="https://www.fastexpert.com/agents/krystle-roth-2375/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 text-brand-forest hover:underline" data-id="element-154">
            FastExpert <ExternalLink size={10} data-id="element-155" />
          </a>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-156">
          {servedAreas.map(z => <div key={z.zip} className="flex items-center gap-3 px-4 py-3 bg-brand-sage/50 border border-brand-light rounded-xl hover:border-brand-forest/30 transition-colors" data-id="element-157">
              <div className="flex flex-col items-center justify-center w-12" data-id="element-158">
                <span className="font-mono text-sm font-medium text-brand-forest" data-id="element-159">
                  {z.zip}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-160">
                <p className="text-sm font-medium text-brand-dark truncate" data-id="element-161">
                  {z.name}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}